import { DataProvider } from "./DataContext/DataContext";
import AdminLayout from "./Layout/Layout";
import "./Admin.scss";



export default function AdminPage() {/* 
  const {isAuthenticated} = useLoaderData();
     if(isAuthenticated){
      throw redirect("/login");
     }
   */
   return (
    <DataProvider>
       <AdminLayout/>
    </DataProvider>
  )}